<script lang="ts" setup>
import { computed, inject, ref } from 'vue';
import { useField } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import { isDisabledInjectionKey } from '@relatie-lib/relatieGegevens/relatiegegevensForm/keys';
import { useTussenpersonenGet } from '@services/crm-internal/orval-api/tussenpersonen-api/tussenpersonen-api';
import { useClaims } from '@auth/useClaims';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import VSelect from '@shared/form/VSelect/VSelect.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';

const adviseurFieldId = 'relatiegegevens-relatie-adviseur';

const claims = useClaims();

const { data, isPending } = useTussenpersonenGet(undefined, {
  query: {
    select: (r) => r.result?.map((a) => ({ label: `${a.name} (${a.id})`, value: a.id })) ?? [],
  },
});

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });

const { errors, setValue } = useField(
  'adviseurnummer',
  computed(() =>
    toTypedSchema(claims.value?.isInternal ? z.number() : z.number().optional().nullable()),
  ),
);

const modelValue = ref();
</script>

<template>
  <FieldRowV2 required v-bind="$attrs" :errors label="Adviseur" :label-for="adviseurFieldId">
    <VSkeleton height="lg" v-if="isPending" />
    <VSelect
      v-else
      searchable
      class="w-full"
      :options="data"
      option-label="label"
      :disabled="hasDisabledParent"
      v-model="modelValue"
      @update:modelValue="(e) => setValue(e.value)"
      :id="adviseurFieldId"
    />
  </FieldRowV2>
</template>
